export default "__VITE_ASSET__DJYpvG4N__"